export default __webpack_public_path__ + "static/media/include_14_female@2x.4a0e7ab5.jpg";